var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20605 14.431C4.20605 9.03527 8.58019 4.66113 13.976 4.66113C19.3717 4.66113 23.7459 9.03527 23.7459 14.431C23.7459 17.1084 22.6689 19.5342 20.9245 21.299C20.9108 21.312 20.8971 21.3252 20.8836 21.3387C20.8701 21.3522 20.8569 21.3658 20.8439 21.3796C19.0792 23.124 16.6533 24.2009 13.976 24.2009C8.58019 24.2009 4.20605 19.8268 4.20605 14.431ZM22.1959 25.4794C19.9017 27.189 17.057 28.2009 13.976 28.2009C6.37105 28.2009 0.206055 22.0359 0.206055 14.431C0.206055 6.82613 6.37105 0.661133 13.976 0.661133C21.5809 0.661133 27.7459 6.82613 27.7459 14.431C27.7459 17.5121 26.7339 20.3568 25.0243 22.651L30.2981 27.9248C31.0792 28.7058 31.0792 29.9722 30.2981 30.7532C29.5171 31.5343 28.2508 31.5343 27.4697 30.7532L22.1959 25.4794Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteIcon);
export default __webpack_public_path__ + "static/media/search_white_icon.9846b6bcb2d4458bf63a96421a9c65d6.svg";
export { ForwardRef as ReactComponent };